import { get } from 'lodash';

const styles = theme => ({
  content: {
    margin: 24,
    minHeight: 'calc(100vh - 56vw)',
    backgroundColor: get(theme, 'color.background'),
    marginBottom: 70,
  },
  bodyContent: {
    marginTop: 10,
    marginBottom: 10,
  },
  pageTitle: {
    color: get(theme, 'color.pageTitle'),
    fontSize: get(theme, 'fontSize.pageTitle'),
    fontFamily: get(theme, 'typography.pageTitle'),
    margin: 10,
    display: 'inline-block',
  },
  actionButtonsContainer: {
    display: 'inline-block',
    float: 'right',
    '& button': {
      marginLeft: 10,
    },
  },
  divider: {
    marginTop: 4,
    backgroundColor: get(theme, 'color.borderColor'),
  },
  enrollmentSectionTitle: {
    color: get(theme, 'color.sectionTitle'),
    fontSize: get(theme, 'fontSize.sectionTitle'),
    fontFamily: get(theme, 'typography.sectionTitle'),
    margin: 10,
    display: 'inline-block',
  },
  attributeContainer: {
    width: '16%',
    display: 'inline-block',
    margin: '0.5%',
    padding: '1.5%',
    verticalAlign: 'top',
    backgroundColor: get(theme, 'color.uiBackground'),
    color: get(theme, 'color.bodyText'),
    fontSize: get(theme, 'fontSize.bodyText'),
    fontFamily: get(theme, 'typography.bodyText'),
    '& span': {
      fontWeight: 'bold',
    },
  },
  copiedText: {
    color: get(theme, 'color.success'),
    fontSize: get(theme, 'fontSize.smallText'),
    fontFamily: get(theme, 'typography.smallText'),
    fontStyle: 'italic',
    fontWeight: 'bold',
    paddingLeft: 10,
  },
  enrollSection: {
    flexGrow: 1,
  },
  enrollSectionCard: {
    padding: theme.spacing(2),
    color: get(theme, 'color.bodyText'),
    backgroundColor: get(theme, 'color.uiBackground'),
    minHeight: 100,
    '& input': {
      padding: 10,
      marginTop: 10,
      marginBottom: 10,
      width: '60%',
    },
  },
  selectUrlButton: {
    borderRadius: '0 4px 4px 0',
    verticalAlign: 'middle',
  },
  enrollSectionColTitle: {
    fontWeight: 'bold',
  },
  enrollSectionColDesc: {
    fontSize: 12,
  },
  loadingSpinner: {
    width: 30,
    height: 30,
    marginTop: 10,
    color: get(theme, 'color.bodyText'),
  },
  notificationWidthClass: {
    width: '96%',
    padding: '0 15px',
    marginLeft: 0,
  },
  subTitle: {
    fontSize: get(theme, 'fontSize.smallText'),
    fontStyle: 'italic',
    float: 'right',
    marginRight: 50,
    marginTop: 5,
  },
  helpIcon: {
    fontSize: 12,
    margin: get(theme, 'margin.m4'),
    verticalAlign: 'inherit',
    cursor: 'pointer',
    color: `${get(theme, 'color.link')} !important`,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/ApiProxy/Details/styles.js